import React, { useEffect } from "react";
import "./metodologia.css";
import data from "../../json/cimetodologiaitems";

const Metodologia = () => {

  // =================================================
  // 🔹 SCROLL AL INICIO
  // =================================================
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // =================================================
  // 🔹 FUNCIÓN PARA OBTENER ICONO POR TIPO DE ARCHIVO
  // =================================================
  const getIconoArchivo = (tipo) => {
    const iconos = {
      PDF: "📄",
      EXCEL: "📊",
      WORD: "📝",
      POWERPOINT: "📽️",
      ZIP: "🗜️",
      DEFAULT: "📁"
    };
    return iconos[tipo?.toUpperCase()] || iconos.DEFAULT;
  };

  // =================================================
  // 🔹 FUNCIÓN PARA OBTENER COLOR POR TIPO
  // =================================================
  const getColorTipo = (tipo) => {
    const colores = {
      PDF: "#e74c3c",
      EXCEL: "#27ae60",
      WORD: "#2980b9",
      POWERPOINT: "#e67e22",
      ZIP: "#7f8c8d"
    };
    return colores[tipo?.toUpperCase()] || "#95a5a6";
  };

  return (
    <div
      className="container-full-width cinterno-bg"
      style={{
        backgroundImage: `url(${data.background})`,
        backgroundSize: "30%",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
        width: "100%",
        minHeight: "100vh"
      }}
    >

      {/* ================================================= */}
      {/* 1️⃣ ENCABEZADO */}
      {/* ================================================= */}
      <h3
        className='title'
        style={{
          color: 'var(--wine)',
          fontWeight: 'bold',
          textAlign: 'center'
        }}
      >
        Metodología
      </h3>
      <hr className='hr-gob' />

      {/* ================================================= */}
      {/* 2️⃣ ENLACES */}
      {/* ================================================= */}
      <div className="subheader-links">
        {data.links?.map((link, index) => (
          <a key={index} href={link.url} className="link-custom">
            {link.texto}
          </a>
        ))}
      </div>

      {/* ================================================= */}
      {/* 4️⃣ CONTENIDO (PDFs - EXISTENTE) */}
      {/* ================================================= */}
      <div className="pdf-section">

        {data.pdfs?.map((item) => (
          <div className="pdf-block" key={item.id}>

            {/* 🔴 CUADRO DE TEXTO */}
            <div className="cuadro-text">
              <h4>{item.tituloTexto}</h4>

              <p
                dangerouslySetInnerHTML={{
                  __html: item.descripcion
                }}
              />

              {/* ⚪ PDF (MISMO ANCHO) */}
              <div className="pdf-viewer-container">

                <h4 className="pdf-viewer-title">
                  {item.tituloPdf}
                </h4>

                <iframe
                  src={item.url}
                  title={item.tituloPdf}
                />

              </div>
            </div>

          </div>
        ))}

      </div>

      {/* ================================================= */}
      {/* 3️⃣ SECCIÓN DE DESCARGAS (NUEVA) */}
      {/* ================================================= */}
      {data.descargas && data.descargas.length > 0 && (
        <div align = 'center' className="descargas-section">

          <div className="descargas-grid">
            {data.descargas.map((archivo) => (
              <a
                key={archivo.id}
                href={archivo.url}
                download={archivo.nombreArchivo}
                className="descarga-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* Icono del archivo */}
                <div 
                  className="descarga-icono"
                  style={{ color: getColorTipo(archivo.tipo) }}
                >
                  {archivo.icono || getIconoArchivo(archivo.tipo)}
                </div>

                {/* Información del archivo */}
                <div className="descarga-info">
                  <span 
                    className="descarga-tipo"
                    style={{ backgroundColor: getColorTipo(archivo.tipo) }}
                  >
                    {archivo.tipo}
                  </span>
                  <h5 className="descarga-titulo">
                    {archivo.titulo}
                  </h5>
                  <span className="descarga-nombre">
                    {archivo.nombreArchivo}
                  </span>
                </div>

                {/* Botón de descarga */}
                <div className="descarga-boton">
                  <span>⬇️ Descargar</span>
                </div>
              </a>
            ))}
          </div>

        </div>
      )}

    </div>
  );
};

export default Metodologia;